<template>
  <div>
    <div class="flex justify-between mb-6 items-center">
      <h2 class="font-normal text-xl">
        Conversations
      </h2>
      <!--<button-->
        <!--v-if="conversations.length"-->
        <!--@click="toggleComposeEmail"-->
        <!--type="button"-->
        <!--class="inline-flex border rounded px-4 py-3 items-center text-gray-700 font-medium justify-center">-->
          <!--<svg width="20" height="16" viewBox="0 0 20 16" class="block fill-current" fill="none" xmlns="http://www.w3.org/2000/svg">-->
            <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H18C19.103 0 20 0.897 20 2V13C20 14.103 19.103 15 18 15H10V13H18V4L11.6 8.8C11.422 8.933 11.211 9 11 9C10.789 9 10.578 8.933 10.4 8.8L4 4V6H2V2C2 0.897 2.897 0 4 0ZM4.666 2L11 6.75L17.334 2H4.666Z"/>-->
            <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M0 8H7V10H0V8ZM2 12H8V14H2V12ZM9 18V16H5V18H9Z"/>-->
          <!--</svg>-->
          <!--<span class="ml-3 block">Send Email</span>-->
      <!--</button>-->
    </div>
    <div
      v-if="conversations.length"
      class="border rounded bg-white px-8 flex flex-col shadow-inner overflow-auto"
      style="height: calc(100vh - 148px)"
    >
      <div
        class="flex mt-8 mb-4"
        :class="{
        'justify-start border-gray-700': conversation.type == 0,
        'justify-end': conversation.type == 1
      }"
        v-for="conversation in conversations"
      >
        <div class="w-3/4 mt-2">
          <div class="flex items-center justify-between	">
            <div class="flex items-center">
              <Avatar :fullname="conversation.user.full_name"></Avatar>
              <div class="ml-3 flex flex-col">
              <span class="font-medium text-gray-700">{{
                conversation.user.full_name
              }}</span>
                <span class="text-gray-700">{{ conversation.user.email }}</span>
              </div>
            </div>
            <div>
            <span class="text-gray-700">{{
              conversation.created_at.formatted
            }}</span>
            </div>
          </div>
          <div
            class="border-2 border-blue-400 shadow mt-2 ml-10 rounded-lg p-4"
            :class="{
            'bg-gray-200': conversation.type == 0,
            'bg-gray-100': conversation.type == 1
          }"
          >
            <div>
              <p class="text-lg font-medium text-gray-700">
                {{ conversation.subject }}
              </p>
            </div>
            <div class="mt-4 relative text-gray-700">
              <p class="" v-html="conversation.content"></p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <NoRecords v-else>
      <div class="flex items-center flex-col">
        <p>It seems you don't have any conversation yet.</p>
        <!--<button-->
          <!--@click="toggleComposeEmail"-->
          <!--type="button"-->
          <!--class="mt-4 border rounded inline-flex px-4 py-2 items-center text-gray-700 font-medium justify-center">-->
          <!--<svg width="20" height="16" viewBox="0 0 20 16" class="block fill-current" fill="none" xmlns="http://www.w3.org/2000/svg">-->
            <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M4 0H18C19.103 0 20 0.897 20 2V13C20 14.103 19.103 15 18 15H10V13H18V4L11.6 8.8C11.422 8.933 11.211 9 11 9C10.789 9 10.578 8.933 10.4 8.8L4 4V6H2V2C2 0.897 2.897 0 4 0ZM4.666 2L11 6.75L17.334 2H4.666Z"/>-->
            <!--<path fill-rule="evenodd" clip-rule="evenodd" d="M0 8H7V10H0V8ZM2 12H8V14H2V12ZM9 18V16H5V18H9Z"/>-->
          <!--</svg>-->
          <!--<span class="ml-3 block">Send Email</span>-->
        <!--</button>-->
      </div>
    </NoRecords>
    <!--<ComposeEmail v-if="composeEmail" @close="toggleComposeEmail"></ComposeEmail>-->
  </div>
</template>

<script>
import axios from "axios";
import Avatar from "@/components/Avatar.vue";
import NoRecords from "@/components/NoRecords.vue";
// import ComposeEmail from "@/components/ComposeEmail.vue";

export default {
  name: "Conversation",
  components: {
    Avatar,
    NoRecords,
    // ComposeEmail,
  },
  data() {
    return {
      composeEmail: false,
      conversations: []
    };
  },
  async beforeRouteEnter(to, from, next) {
    let response = await axios.get("/api/conversations");
    next(vm => {
      vm.conversations = response.data;
    });
  },
  methods: {
    toggleComposeEmail() {
      this.composeEmail = !this.composeEmail;
      this.fetch();
    },
    async fetch() {
      let response = await axios.get("/api/conversations");
      this.conversations = response.data;
    }
  }
};
</script>
